import {Component, inject} from '@angular/core';
import {BaseModalComponent} from '../base-modal/base-modal.component';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {MIN_PASSWORD_LENGTH} from '../../../constants/constants';
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {RecordData} from '../../../types/records-table.types';
import {MatIcon} from "@angular/material/icon";
import {changePasswordModalName} from "./configs/change-password-config";

@Component({
  selector: 'app-change-password-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    ReactiveFormsModule,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatButton,
    MatIconButton,
    MatSuffix,
    MatIcon
  ],
  templateUrl: './change-password-modal.component.html',
  styleUrls: [
    '../base-modal/base-modal.component.scss',
    './change-password-modal.component.scss'
  ]
})
export class ChangePasswordModalComponent extends BaseModalComponent {
  protected changePasswordFormGroup: FormGroup = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(MIN_PASSWORD_LENGTH)
    ]),
    confirmPassword: new FormControl('', [
      Validators.required
    ]),
  })
  protected readonly MIN_PASSWORD_LENGTH = MIN_PASSWORD_LENGTH;

  private data: { recordData: RecordData } = inject(MAT_DIALOG_DATA);

  public passwordVisible: boolean = true;
  public confirmPasswordVisible: boolean = true;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(changePasswordModalName);
    this.onPasswordChanges();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(changePasswordModalName);
  }

  protected changePassword(): void {
    const password: string = this.changePasswordFormGroup.get('password')!.value;
    this.baseModalApiService.changeUserPassword(this.data.recordData['login'] as string, password).subscribe({
      next: () => this.snackbarService.showMessage({message: 'Пароль успешно изменен'})
    });

    this.closeDialog('success');
  }

  protected handleNewPasswordInputChange(event: Event): void {
    const newPasswordValue = (event.target as HTMLInputElement).value;

    this.changePasswordFormGroup.get('confirmPassword')!.setValidators([
      Validators.required,
      this.matchPassword(newPasswordValue)
    ]);
  }

  public togglePasswordVisibility(): void {
    this.passwordVisible = !this.passwordVisible;
  }

  public toggleConfirmPasswordVisibility(): void {
    this.confirmPasswordVisible = !this.confirmPasswordVisible;
  }

  private onPasswordChanges() {
    this.changePasswordFormGroup.get('password')?.valueChanges.subscribe(password => {
      const confirmPasswordControl = this.changePasswordFormGroup.get('confirmPassword');
      if (password) {
        confirmPasswordControl?.setValidators([
          Validators.required,
          Validators.minLength(MIN_PASSWORD_LENGTH),
          this.matchPassword(password)
        ]);
      } else {
        confirmPasswordControl?.clearValidators();
      }
      confirmPasswordControl?.updateValueAndValidity();
    });
  }

  private matchPassword(password: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value === password ? null : {mismatch: true};
    };
  }
}
